import { apiFetch } from '../../shared/api/apiClient';

// task-36: open string type — the backend canonical list (SUPPORTED_PAYMENT_PROVIDERS in localVars.ts)
// is the authoritative source. Hard-coding the union here duplicated that list and required changes
// in two places when adding a new provider. Runtime validation is done via useSupportedProviders.
export type PaymentModeValue = string;

export type AdminUserItem = {
  id: string;
  email: string;
  role: 'admin' | 'user';
  createdAt: string;
  lastLogin: string;
  paymentMode?: PaymentModeValue | null;
};

export async function fetchUsers(): Promise<AdminUserItem[]> {
  const res = await apiFetch('/api/users');
  if (!res.ok) throw new Error('Failed to fetch users');
  return res.json();
}

export async function updateUserRoleApi(id: string, role: 'admin' | 'user'): Promise<{ success: boolean; id: string; role: string }> {
  const res = await apiFetch(`/api/users/${id}/role`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ role })
  });
  if (!res.ok) throw new Error('Failed to update user role');
  return res.json();
}

export async function createUser(email: string, password: string) {
  const res = await apiFetch('/api/users', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  });
  if (!res.ok) throw new Error('Failed to create user');
  return res.json();
}

export async function deleteUser(id: string) {
  const res = await apiFetch(`/api/users/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error('Failed to delete user');
  return res.json();
}

export async function fetchUserPaymentMode(id: string): Promise<PaymentModeValue | null> {
  const res = await apiFetch(`/api/users/${id}/payment-mode`);
  if (!res.ok) throw new Error('Failed to fetch payment mode');
  const body = await res.json();
  return (body?.paymentMode ?? null) as PaymentModeValue | null;
}

export async function updateUserPaymentMode(
  id: string,
  paymentMode: PaymentModeValue,
  reason?: string
): Promise<{ success: boolean; id: string; paymentMode: PaymentModeValue; previousMode: PaymentModeValue | null; changedBy: string; changedAt: string }> {
  const res = await apiFetch(`/api/users/${id}/payment-mode`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ paymentMode, reason })
  });
  if (!res.ok) {
    let msg = 'Failed to update payment mode';
    try { const b = await res.json(); if (b?.error) msg = b.error; } catch {}
    throw new Error(msg);
  }
  return res.json();
}

export default { fetchUsers, updateUserRoleApi, fetchUserPaymentMode, updateUserPaymentMode };
